import { render, staticRenderFns } from "./App.vue?vue&type=template&id=23979b59&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=23979b59&scoped=scoped&lang=css&"
import style1 from "./App.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23979b59",
  null
  
)

export default component.exports